<template>
  <div class="sidebar">
    <div class="sidebartop">
      <router-link to="/">
        <div class="logoholder">
          <div class="logoReplace">CDT</div>
          <!-- <img class="logo" src="../../assets/sidebar/cdt-logo-orange.png" alt="cad-tekenaar.com logo" /> -->
        </div>
      </router-link>

      <div class="navmenu-wrapper">
        <router-link to="/kaart">
          <div
            class="navitem"
            :class="[
              currentPage.includes('/kaart') ? activeClass : 'activeClass',
              'nav-item'
            ]"
          >
            <img class src="../../assets/sidebar/tekenaarskaart-ico.png" />
          </div>
        </router-link>
        <router-link to="/tekenaars">
          <div
            class="navitem"
            :class="[
              currentPage.includes('/tekenaars') ? activeClass : 'activeClass',
              'nav-item'
            ]"
          >
            <img
              class
              src="../../assets/sidebar/tekenaars-ico.svg"
              alt="cad-tekenaar.com logo"
            />
          </div>
        </router-link>
        <router-link to="/opdrachten">
          <div
            class="navitem"
            :class="[
              currentPage.includes('/opdrachten') ? activeClass : 'activeClass',
              'nav-item'
            ]"
          >
            <img
              class
              src="../../assets/sidebar/opdrachten-ico.svg"
              alt="cad-tekenaar.com logo"
            />
          </div>
        </router-link>
        <router-link to="/tools">
          <div
            class="navitem"
            :class="[
              currentPage == '/tools' ? activeClass : 'activeClass',
              'nav-item'
            ]"
          >
            <img
              class
              style="max-width:29px;"
              src="../../assets/sidebar/links-ico.png"
              alt="cad-tekenaar.com logo"
            />
          </div>
        </router-link>
        <router-link to="/blog">
          <div
            class="navitem"
            :class="[
              currentPage == '/blog' ? activeClass : 'activeClass',
              'nav-item'
            ]"
          >
            <img
              class
              style="max-width:34px;"
              src="../../assets/sidebar/blog.png"
              alt="cad-tekenaar.com logo"
            />
          </div>
        </router-link>
      </div>
    </div>

    <div class="sidebarbottom">
      <!--  -->

      <!-- <div class="links">
        <a href="https://cad-tekenaar.com" target="_blank">
          <div class="circle" style="background-color:#144b89;">
            <h3 style="font-weight:600;">CDT</h3>
          </div>
        </a>
        <a href="https://team.cad-tekenaar.com" target="_blank">
          <div class="circle" style="background-color:#999;">
            <h3 style="font-weight:600;">Team</h3>
          </div>
        </a>
        <a href="https://cad-tekena7950.activehosted.com/admin/" target="_blank">
          <div class="circle" style="background-color:#1c9ed9;">
            <h3 style="font-weight:600;">MB</h3>
          </div>
        </a>
      </div> -->

      <div class="navitem" @click="$emit('open-logModal')">
        <img class="logitem" src="../../assets/sidebar/beta-log-ico.png" />
      </div>
      <div class="navitem" @click="csvExportTekenaars">
        <img
          class="logitem"
          style="transform:translateX(3px)"
          src="../../assets/sidebar/export-ico.png"
        />
      </div>
      <div
        class="navitem"
        @click="setMessengerStatusFalse"
        v-if="status && status.messenger"
      >
        <div class="messengerbolletje"></div>
        <img
          class="logitem messengerActive"
          src="../../assets/sidebar/messenger-ico.png"
        />
      </div>
      <div class="navitem" v-if="status && !status.messenger">
        <img style="opacity:.3;" src="../../assets/sidebar/messenger-ico.png" />
      </div>
      <!--  -->
    </div>
  </div>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      activeClass: 'active',
      activeClassOrange: 'activeOrange'
    }
  },
  computed: {
    ...mapGetters(['allTekenaars', 'allOpdrachten']),

    currentPage () {
      return this.$route.path
    },
    status () {
      return store.state.status 
    },

    csvDataOpdrachten () {
      return this.allOpdrachten.map(item => ({
        id: item.id || '',
        opdrachtnummer:
          'CDT.' + item.opdrachtnummerjaar + '.' + item.opdrachtnummer || '',
        opdrachtgever: item.bedrijfsnaam || '',
        emailOpdrachtgever: item.email || '',
        telefoonnummerOpdrachtgever: item.telefoonnummer || '',
        contactpersoon: item.voornaam + ' ' + item.achternaam || '',
        status: item.status || '',
        // omschrijving: item.omschrijving || '',
        discipline: item.disciplines || '',
        werkplek: item.werkplek || '',
        tekenprogramma: item.tekenprogramma || '',
        gekoppeldeTekenaar: item.tekenaarsid || ''
        // intake: item.intake || ''
      }))
    },
    csvDataTekenaars () {
      return this.allTekenaars.map(item => ({
        id: item.id || '',
        voornaam: item.voornaam || '',
        achternaam: item.achternaam || '',
        naam: item.voornaam + ' ' + item.achternaam || '',
        disciplines: item.disciplines || ['geen disciplines...'],
        // aantekening: item.aantekening || '',
        email: item.email || '',
        telefoonnummer: item.telefoonnummer || '',
        tekenprogramma: item.tekenprogramma || '',
        woonplaats: item.woonplaats || '',
        bedrijfsnaam: item.bedrijfsnaam || '',
        website: item.website || '',
        opleiding: item.opleiding || '',
        kvknummer: item.kvknummer || '',
        werkgebied: item.werkgebied || '',
        adres: item.adres || ''
      }))
    }
  },
  methods: {
    setMessengerStatusFalse () {
      if (confirm("Zet notificatie op 'gelezen'?")) {
        store.dispatch('setMessengerStatusFalse')
        if (confirm('wil je direct Mailblue openen?')) {
          var win = window.open(
            'https://cad-tekena7950.activehosted.com/app/contacts?listid=21',
            '_blank'
          )
          win.focus()
        }
      }
    },

    csvExport (arrData) {
      let csvContent = 'data:text/csv;charset=utf-8,'
      csvContent += [
        Object.keys(arrData[0]).join(';'),
        ...arrData.map(item => Object.values(item).join(';'))
      ]
        .join('\n')
        .replace(/(^\[)|(\]$)/gm, '')

      const data = encodeURI(csvContent)
      const link = document.createElement('a')
      link.setAttribute('href', data)
      link.setAttribute('download', 'export.csv')
      link.click()
    },
    csvExportTekenaars () {
      this.$modal.show('dialog', {
        title: 'Backup / Export',
        text: 'Maak een data-dump van je gegevens',
        buttons: [
          {
            title: 'Tekenaars',
            handler: () => {
              this.csvExport(this.csvDataTekenaars)
            }
          },
          {
            title: 'Opdrachten',
            default: true,
            handler: () => {
              this.csvExport(this.csvDataOpdrachten)
            }
          }
        ]
      })
      // this.csvExport(this.allTekenaars);
    }
  }
}
</script>

<style scoped>
.logoReplace {
  width: 50px;
  height: 50px;
  font-size: 18px;
  color: #ff9326;
  border-radius: 100%;
  border: 2px solid #ff9326;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

/* Ipad version */
/* ipad Mini Portrait */
@media only screen and (max-width: 1024px) {
  .sidebarbottom {
    display: none;
  }
}

.links {
  padding-left: 14px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-bottom: 15px;
}
a {
  text-decoration: none !important;
}
.circle {
  background-color: none;
  text-decoration: none;
  display: flex;
  width: 34px;
  height: 34px;
  font-size: 8px;
  font-weight: 600;
  margin-bottom: 30px;
  border: 1.5px solid white;
  cursor: pointer;
  color: white;
  align-items: center;
  justify-content: center;
  /* filter: grayscale(); */
  opacity: 0.4;
  background-color: rgb(00, 00, 00, 0) !important;
}
.circle:hover {
  filter: none;
  opacity: 1;
}
a .circles h3 {
  display: inline;
}

.sidebar {
  z-index: 3;
  height: 100%;
  max-height: 100%;
  position: fixed;
  top: 0;
  min-width: 100px;
  /* height: 100vh; */
  background-color: #0b1126;
  color: fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 20px;
}

.sidebarbottom .navitem {
  padding: 15px 37px;
  border-bottom: 0;
}

.sidebarbottom .navitem .logitem {
  max-width: 30px;
}

.navitem {
  display: flex;
  padding: 30px;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #354053;
  max-width: 100px;
  position: relative;
}

.messengerActive {
  opacity: 1 !important;
}

/** sidebar icons on active */
.active {
  background-color: #3076ea;
}

.activeOrange {
  background-color: #ff9326;
}

.logitem {
  max-width: 35px;
  opacity: 0.3;
  cursor: pointer;
  transition: 0.2s;
}
.logitem:hover {
  opacity: 1;
}

.messengerbolletje {
  width: 12px;
  height: 12px;
  background-color: red;
  position: absolute;
  top: 30px;
  right: 30px;
  border-radius: 100px;
}

/** sidebar logo holder */
.logoholder {
  display: flex;
  padding: 30px 0;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #354053;
}
.logo {
  width: 50px;
  height: 50px;
}

@media screen and (max-width: 663px) {
  /* For mobile */
  .logoholder {
    display: none;
  }
  .sidebar {
    width: 100%;
    position: fixed;
    height: 70px;
    bottom: 0px;
  }
  .navmenu-wrapper {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
  }
}
</style>
